import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RealtimeComponent } from './realtime.component';
import { RealtimeListComponent } from './realtime-list/realtime-list.component';
import { SharedModule } from '../../../shared/shared.module';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { RealtimeTreatmentComponent } from './realtime-treatment/realtime-treatment.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { RealtimeRoutingModule } from './realtime-routing.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { RealtimeTreatmentService } from './realtime-treatment/realtime-treatment.service';
import { TreatmentDataPanelComponent } from './realtime-panel/treatment-data-panel.component';

@NgModule({
  declarations: [
    RealtimeComponent,
    RealtimeTreatmentComponent,
    RealtimeListComponent,
    TreatmentDataPanelComponent
  ],
  exports: [
    RealtimeTreatmentComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgbPaginationModule,
    Ng2SmartTableModule,
    ColorPickerModule,
    HighchartsChartModule,
    RealtimeRoutingModule,
  ],
  providers: [
    // RealtimeTreatmentService
  ],
})
export class RealtimeModule { }
